import _ from "underscore";
import $ from "jquery";

import "vendor/bootstrap"; // for popover

import ListItemView from "backdraft-app/src/listing/item";

import ListActionDropdown from "../list_action_dropdown";

import template from "./templates/item.jst";

export default class SortableListItem extends ListItemView {
  get tagName() { return "li"; }

  attributes() {
    return {
      "data-element": "item",
      "data-model-id": this.model.get("id")
    };
  }

  get events() {
    return {
      "click [data-action='remove-item']": "_handleRemove"
    };
  }

  render() {
    this.selection = this.parent.options.selection;
    this.ordered = this.parent.options.ordered;
    this.$el.html(template(
      {
        readOnly: this.parent.options.readOnly,
        selection: this.selection,
        ordered: this.ordered,
        model: this.model,
        badgeContent: this.model.get("badgeContent"),
        warningContent: this.model.get("warningContent")
      }
    ));

    this.$el.icon();
    this.$el.data('cid', this.cid);

    if (this.model.get("menu")) {
      this._renderMenu();
    }

    if (this.model.get("warningContent")) {
      this._renderWarning();
    }

    this._wireEvents();

    return this;
  }

  close() {
    this.$(".sortable-list__item--active").off();
    super.close();
  }

  _handleRemove(e) {
    e.preventDefault();
    this.closeItem();
    return false;
  }

  _handleRadioSelectionClick(e) {
    if (this.$(e.target).data("mount") !== "warning-content") { // Don't do anything if clicking on the warning icon with popover
      e.preventDefault();
      this.parent.parent.trigger("sortable-list:radio-item-selected", this.model);
    }
  }

  _renderMenu() {
    const menuOptions = this.model.get("menu");
    const items = menuOptions.items.map(this._normalizeMenuItems.bind(this));
    const dropDown = new ListActionDropdown(_.extend({}, menuOptions, { items }));

    this.$("[data-mount='menu']").append(dropDown.render().$el);
  }

  _renderWarning() {
    this.$("[data-mount='warning-content']").popover({
      content: this.model.get('warningContent'),
      trigger: 'hover',
      placement: "top"
    });
  }

  _normalizeMenuItems(itemWithoutModel) {
    const originalAction = itemWithoutModel.action;
    const actionWithModel = event => {
      originalAction.apply(this, [this.model]);
    };

    return _.extend({}, itemWithoutModel, { action: actionWithModel });
  }

  _wireEvents() {
    // because of dragging - we need to have smarts here on when to add the hover class
    //  can't just use :hover in CSS
    this.$(".sortable-list__item--active").on("mouseover", function(evt) {
      // ensure not in a drag event
      if (evt.buttons === 0) {
        $(this).addClass("sortable-list__item--hover");
      }
    });

    this.$(".sortable-list__item--active").on("mouseout", function() {
      $(this).removeClass("sortable-list__item--hover");
    });

    if (this.selection === "radio") {
      this.$el.on("click", this._handleRadioSelectionClick.bind(this));
    }
  }
}
